<p-card [header]="profileService.title()" styleClass="p-4 shadow-md w-full lg:w-fit" class="items-center flex justify-center lg:px-8 md:px-6 px-4 py-0">
  <div class="login">
    <!-- <h1 class="p-card-title"> Login </h1> -->
    <div [formGroup]="loginFormGroup" class="mb-6">
      <label [for]="enum.username" [class]="labelClass()">Nombre de usuario</label>
      <input
        [id]="enum.username"
        [type]="enum.text"
        placeholder="Nombre de usuario"
        pInputText
        [ngClass]="{'ng-invalid ng-dirty': isInvalid(enum.username)}"
        [formControlName]="enum.username">
        <label [for]="enum.password" [class]="labelClass()">Contraseña</label>
      <input
        [id]="enum.password"
        [type]="enum.password"
        placeholder="Contraseña"
        pInputText
        [ngClass]="{'ng-invalid ng-dirty': isInvalid(enum.password)}"
        [formControlName]="enum.password">
    </div>
    <button
      pButton
      label="Sign In"
      icon="pi pi-user"
      class="w-full"
      (click)="signIn()"
    ></button>
  </div>
</p-card>
